export const messages = {
  featureNotDetected: 'Could not detect features whether it should be throttled or debounced',
  callbackNotFound: "Method <method> does not exists in component's methods objects",
};
